<script>
export default {
    name: 'sortable',
    props: ['order'],
    methods: {
        getClass: function() {
            var className = '';

            switch(this.order) {
                case 'asc':
                    className = 'mdi-arrow-up';
                    break;

                case 'desc':
                    className = 'mdi-arrow-down';
                    break;

                default:
                    className = 'mdi-arrow-up-down';
                    break;
            }

            return className;
        }
    }
}
</script>

<template>
<i class="float-right mdi" v-bind:class="getClass()"></i>
</template>